import React from 'react';

const brandStyle = {
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontWeight: 800,
  fontStyle: 'italic',
  background: 'linear-gradient(to right, #16a34a, #0d9488)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

const BrandName = ({ className = '' }) => (
  <span className={className} style={brandStyle}>
    Fitnession
  </span>
);

export default BrandName;
